/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReplaceAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function ReplaceAction({
  children,
  onReplaceMatch,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Sync/Content/SyncPatients/Content/PatientNotFoundCard/ReplacePatient/Content/ReplaceAction"
  
}) {
let replaceSelectedPatientValueData = fromData.useDataValue({ viewPath,
context: 'replace',
path: 'selected_patient',
})
let onClick = fromHelpers.useOnClick({
  children,
  onReplaceMatch,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 onClick={onClick}
 type="primary"
 text="Match"
 data="replace.selected_patient"
 disabled={!replaceSelectedPatientValueData}
/>
{children}
</React.Fragment>)
}